/**
 * @ngdoc config
 * @name routeProviderConfig
 * @description
 * Sets the routes for the Media section:
 * - The default one (`/`).
 *
 * @param {Service} $routeProvider The interface for the Angular router.
 * @memberof media
 */
const routeProviderConfig = ($routeProvider) => {
  'ngInject';

  $routeProvider
  .when('/campaign/:campaignId/media/:mediaId', {
    template: ({ mediaId, campaignId }) =>
      `<media type="campaign" media-id="${mediaId}" campaign-id="${campaignId}"></media>`,
  })
  .when('/community/media/:mediaId', {
    template: ({ mediaId }) => `<media type="community" media-id="${mediaId}"></media>`,
  })
  .when('/profile/media/:mediaId', {
    template: ({ mediaId }) => `<media type="profile" media-id="${mediaId}"></media>`,
  });
};

export default routeProviderConfig;



// WEBPACK FOOTER //
// ./src/frontend/modules/media/configs/routeProvider.config.js